export const userLoginMethods = {
    status: false, // indicates if user exists
    password: false,
    google: false,
}